<template>
  <base-modal-ex :active.sync="isActive"
    :animation-in="animationIn"
    :animation-out="animationOut"
    :animation-duration="animationDuration"
    :can-cancel="false"
    :min-width="30"
    :min-height="50"
    has-modal-card>
    <header class="modal-card-head">
      <p class="modal-card-title is-flex-items-center">
        <span>New Batch</span>
      </p>
    </header>
    <section class="modal-card-body">
      <div class="field">
        <div class="columns is-multiline">
          <div class="column is-full-mobile is-half-tablet">
            <label class="label">Average Cost Target</label>
            <div class="control">
              <vue-numeric class="input has-text-right"
                v-model="value.agreedArc"
                :min="0"
                symbol="$"
                :precision="2" />
            </div>
          </div>
          <div class="column is-full-mobile is-half-tablet">
            <label class="label">Min Batch Size</label>
            <div class="control">
              <vue-numeric class="input has-text-right"
                v-model="value.minBatchSize"
                :min="0" />
            </div>
          </div>
        </div>
      </div>
      <div class="field">
        <div class="columns is-multiline">
          <div class="column is-full-mobile is-half-tablet">
            <label class="label">Total Value (ex GST)</label>
            <div class="control">
              <vue-numeric class="input has-text-right"
                v-model="value.perQuoteTotalMin"
                :min="0"
                symbol="$"
                :precision="2" />
            </div>
          </div>
          <div class="column is-full-mobile is-half-tablet">
            <label class="label">to</label>
            <div class="control">
              <vue-numeric class="input has-text-right"
                v-model="value.perQuoteTotalMax"
                :min="0"
                symbol="$"
                :precision="2" />
            </div>
          </div>
        </div>
      </div>
      <div class="field">
        <div class="columns is-multiline">
          <div class="column is-full-mobile is-half-tablet">
            <label class="label">ALR Lower Threshold</label>
            <div class="control">
              <vue-numeric class="input has-text-right"
                v-model="value.alrLowerThreshold"
                :min="0"
                symbol="$"
                :precision="2" />
            </div>
          </div>
          <div class="column is-full-mobile is-half-tablet">
            <label class="label">ALR Upper Threshold</label>
            <div class="control">
              <vue-numeric class="input has-text-right"
                v-model="value.alrUpperThreshold"
                :min="0"
                symbol="$"
                :precision="2" />
            </div>
          </div>
        </div>
      </div>
    </section>
    <footer class="modal-card-foot is-flex is-justify-content-flex-end">
      <div class="buttons">
        <button class="button is-success tooltip"
          data-tooltip="Save"
          @click="add">
          <span class="icon">
            <i class="mdi mdi-plus mdi-20px" />
          </span>
          <span>Add</span>
        </button>
        <button class="button tooltip"
          @click="close"
          data-tooltip="Close">
          <span class="icon">
            <i class="mdi mdi-close mdi-20px" />
          </span>
          <span>Close</span>
        </button>
      </div>
    </footer>
  </base-modal-ex>
</template>

<script>
import { BaseModalEx } from '@/components/BulmaModal'
// import Multiselect from 'vue-multiselect'
// import OrmBatchingService from './OrmBatchingService'
// import _debounce from 'lodash.debounce'
import VueNumeric from '@/components/VueNumeric'
// import _cloneDeep from 'lodash/cloneDeep'

export default {
  name: 'OrmBatchingNewModal',
  components: { BaseModalEx, VueNumeric },
  props: {
    value: null,
    active: {
      type: Boolean,
      default: false
    },
    animationIn: {
      type: String,
      default: 'zoomIn'
    },
    animationOut: {
      type: String,
      default: 'zoomOut'
    },
    animationDuration: {
      type: [String, Number],
      default: 0.3
    }
  },
  data: () => {
    return {
      // innerValue: {},
      isActive: false
      // insurers: [],
      // isInsurerLoading: false,
      // selectedInsurer: null,
      // selectedBatchType: null
    }
  },
  computed: {

  },
  watch: {
    // value: {
    //   handler: function (newVal, oldVal) {
    //     this.innerValue = _cloneDeep(newVal)
    //   }
    // },
    active: {
      handler: function (newVal, oldVal) {
        this.isActive = newVal
        if (this.isActive) {
          // this.setBatchType()
          // if (this.value && this.value.quoteSystemType) {
          //   this.value.quoteSystemType = CompanyQuoteSystemTypes.ORM
          // }
        }
      },
      deep: true
    }
  },
  async created() {
  },
  async mounted() {},
  methods: {
    // setBatchType() {
    //   this.selectedBatchType = this.batchTypes.find((i) => i.key === this.innerValue.batchType)
    // },
    close() {
      this.$emit('update:active', false)
      this.$emit('close')
    },
    add() {
      this.$emit('update:active', false)
      // if (!this.value.quoteSystemType) {
      //   this.$notification.error('Batch Setting', 'Batch Type is not selected')
      //   return
      // }
      this.$emit('add')
    }
    // async getInsurerDropdown(name) {
    //   this.isInsurerLoading = true
    //   this.insurers = await OrmBatchingService.getInsurerDropdown(name)
    //   if (this.insurers && !this.selectedInsurer && this.lastBatchInsurerId) {
    //     const match = this.insurers.find(i => i.insurerId == this.lastBatchInsurerId)
    //     if (match) {
    //       this.selectedInsurer = match
    //     }
    //   }
    //   this.isInsurerLoading = false
    // },
    // getListComboInsurersFiltered: _debounce(async function (name) {
    //   this.getInsurerDropdown(name)
    // }, 500)
  }
}
</script>